// Function to detect speech segments with proper pause handling
export const detectSpeechSegments = (pitch, intensity, minPauseDuration = 0.3) => {
  const segments = [];
  let currentSegment = null;
  let lastVoicedTime = -1;
  
  for (let i = 0; i < pitch.xs.length; i++) {
    const time = pitch.xs[i];
    const pitchValue = pitch.ys[i];
    
    // Find corresponding intensity
    const intensityIndex = intensity.xs.findIndex(t => Math.abs(t - time) < 0.01);
    const intensityValue = intensityIndex >= 0 ? intensity.ys[intensityIndex] : 0;
    
    const isVoiced = pitchValue > 0 && intensityValue > 0.1;
    
    if (isVoiced) {
      if (!currentSegment) {
        currentSegment = {
          start: time,
          end: time,
          pitches: [pitchValue],
          intensities: [intensityValue],
          times: [time]
        };
      } else {
        currentSegment.end = time;
        currentSegment.pitches.push(pitchValue);
        currentSegment.intensities.push(intensityValue);
        currentSegment.times.push(time);
      }
      lastVoicedTime = time;
    } else {
      if (currentSegment) {
        // Check if this is a significant pause
        const timeSinceLastVoiced = time - lastVoicedTime;
        if (timeSinceLastVoiced >= minPauseDuration) {
          // Finalize the segment
          currentSegment.duration = currentSegment.end - currentSegment.start;
          currentSegment.averagePitch = currentSegment.pitches.reduce((a, b) => a + b, 0) / currentSegment.pitches.length;
          currentSegment.averageIntensity = currentSegment.intensities.reduce((a, b) => a + b, 0) / currentSegment.intensities.length;
          currentSegment.peakIntensity = Math.max(...currentSegment.intensities);
          
          if (currentSegment.duration > 0.1) {
            segments.push(currentSegment);
          }
          currentSegment = null;
        }
      }
    }
  }
  
  // Add the last segment if it exists
  if (currentSegment) {
    currentSegment.duration = currentSegment.end - currentSegment.start;
    currentSegment.averagePitch = currentSegment.pitches.reduce((a, b) => a + b, 0) / currentSegment.pitches.length;
    currentSegment.averageIntensity = currentSegment.intensities.reduce((a, b) => a + b, 0) / currentSegment.intensities.length;
    currentSegment.peakIntensity = Math.max(...currentSegment.intensities);
    
    if (currentSegment.duration > 0.1) {
      segments.push(currentSegment);
    }
  }
  
  return segments;
};

// Function to detect pauses and mark unvoiced segments
export const detectPausesAndMarkUnvoiced = (notes, pitch, intensity, minPauseDuration = 0.2) => {
  if (!notes.length || !pitch?.xs) return notes;
  
  const notesWithPauses = [];
  let lastNoteEnd = 0;
  
  for (let i = 0; i < notes.length; i++) {
    const note = notes[i];
    
    // Check if there's a gap before this note (unvoiced pause)
    if (note.startTime > lastNoteEnd && note.startTime - lastNoteEnd >= minPauseDuration) {
      const pauseDuration = note.startTime - lastNoteEnd;
      
      // Add a pause note
      notesWithPauses.push({
        isUnvoiced: true,
        isPause: true,
        duration: pauseDuration,
        startTime: lastNoteEnd,
        endTime: note.startTime,
        position: ((lastNoteEnd + note.startTime) / 2) / (notes[notes.length - 1].endTime || 1) * 100,
        musicalNote: 'REST',
        time: lastNoteEnd + (pauseDuration / 2),
        pauseDuration: pauseDuration
      });
      
      console.log(`Detected pause: ${pauseDuration.toFixed(2)}s`);
    }
    
    // Add the original note
    notesWithPauses.push(note);
    lastNoteEnd = note.endTime;
  }
  
  return notesWithPauses;
};

// Function to create pitch and intensity segments for analysis
export const createAnalysisSegments = (pitch, intensity) => {
  const pitchSegments = [];
  const intensitySegments = [];
  
  // Create pitch segments (only voiced parts)
  for (let i = 0; i < pitch.xs.length; i++) {
    if (pitch.ys[i] > 0) {
      pitchSegments.push({
        time: pitch.xs[i],
        pitch: pitch.ys[i]
      });
    }
  }
  
  // Create intensity segments
  for (let i = 0; i < intensity.xs.length; i++) {
    if (intensity.ys[i] > 0) {
      intensitySegments.push({
        time: intensity.xs[i],
        intensity: intensity.ys[i]
      });
    }
  }
  
  return { pitchSegments, intensitySegments };
};